import store from "@/store";
import router from "@/routes";
import Vue from "vue";
import * as websocket from "@/api/ws.js";

export const getDeviceType = () => process.env.VUE_APP_OS_TYPE;

// 서비스 타입 구분 - GOLF/NOW 모드 전환용
export const serviceType = process.env.VUE_APP_SERVICE_TYPE;
export const isGolf = serviceType === "GOLF";
export const isNow = serviceType === "NOW";

const replaceView = (viewName = "nosubscr") => {
  Vue.prototype.$progress.$emit("off:progress");
  router.replace({
    name: viewName,
    params: {
      t: new Date().getTime(),
    },
  });
};

// 로그인 시 사용자 이용권 체크
export const userInScope = (
  userInfo,
  successCallback,
  failureCallback = replaceView,
) => {
  userInfo = userInfo || store.getters.userInfo; // 유저 정보 없을 시 Store에서 조회
  if (hasOwnProperty.call(userInfo, "scope")) {
    // scope 배열 4번째 값 확인 (smarttv 이용권 여부 [1||0])
    if (userInfo.scope[3] == 1) return successCallback();
  }

  // ws 연결 해제, localstorage 초기화 진행
  store.dispatch("REQUEST_LOGOUT");
  store.commit("SET_USER_INFO", {});
  return failureCallback();
};

/**
 * `/user/permissions/contents`, `/user/subscription/access` api response의 scope값 비교 (로그인 이후 라우팅 마다 검사)
 * `/user/permissions/contents` api 호출 시 `/user/subscription/access` 미호출 처리
 * @param {*} contentType
 * @param {*} successCallback
 */
export const subInScope = async (contentType, successCallback) => {
  Vue.prototype.$progress.$emit("off:progress");
  if (store.getters.userSubscription) {
    successCallback();
    // userInScope(store.getters.userSubscription, successCallback)
  } else {
    // 세션이 만료된 경우 (TTL 50hours 경과) 자동로그인 시도
    autoLogin(successCallback);
  }
};

export const autoLogin = async (
  successCallback,
  failureCallback = () => replaceView("login"),
) => {
  // 로컬 저장소에 디바이스 정보가 남아있으면 자동 로그인
  const loginId = localStorage.getItem("loginId");
  const uuid = localStorage.getItem("uuid");
  const deviceId = localStorage.getItem("deviceId");

  if (loginId && uuid && deviceId) {
    // ws 연결 해제
    websocket.disconnectWs();
    Vue.prototype.$progress.$emit("off:progress");

    store
      .dispatch("REQUEST_LOGIN", {
        sns: "stv",
        name: loginId,
        uuid: uuid,
        deviceId: deviceId,
      })
      // 이용권 체크 후 없으면 로그인 화면으로 이동 (이용권 구매 화면 아님) NoticeView에서 사용
      .then((response) => {
        userInScope(response.data, successCallback, failureCallback);
      });
  } else {
    store.commit("SET_USER_INFO", {});
    failureCallback();
  }
};

export const checkSession = async () => {
  await store
    .dispatch("CHECK_SESSION")
    .then((response) => {})
    .catch((err) => {});
};

export const lgDeepLinkCheck = async () => {
  let deepLinkValue = sessionStorage.getItem("deepLink");

  if (deepLinkValue) {
    let [type, id] = deepLinkValue.split("_");

    if (type === "live") {
      const checkParams = {
        type: type,
        id: id,
        deepLinkCheck: true,
      };

      // 리그 전용 이용권 시청 권한 확인
      contentsPermissionCheck(checkParams);
    } else {
      router.push({
        name: "player",
        params: {
          vodId: id,
          contentType: type,
        },
      });
    }
  } else {
    router.replace({
      name: "home",
      params: {
        t: new Date().getTime(),
      },
    });
  }
};

/**
 * serviceTypeScope 기준으로 리그 전용 이용권 시청 권한 체크 후 시청 가능한 경우 true 값을 반환
 * 컨텐츠 썸네일 자물쇠용
 * @param {*} gameDesc // 영상 정보
 * @param {*} serviceTypeScope // 리그 전용 이용권 시청 가능 종목 리스트
 */
export function leaguePassPlayCheck(gameDesc, serviceTypeScope) {
  let flag = false;

  if (serviceTypeScope == null) {
    return false;
  }

  serviceTypeScope.forEach((scope) => {
    if (flag) {
      return;
    }

    if (scope.scopeType == "game_type") {
      if (gameDesc.typeId == scope.id) {
        flag = true;
      }
    }

    if (scope.scopeType == "league") {
      if (gameDesc.leagueId == scope.id) {
        flag = true;
      }
    }

    if (scope.scopeType == "season") {
      if (gameDesc.seasonId == scope.id) {
        flag = true;
      }
    }
  });

  return flag;
}

/**
 * 영상 type, id 기준으로 시청권한 체크
 */
export async function contentsPermissionCheck({
  type,
  id,
  deepLinkCheck = false,
}) {
  const response = await store.dispatch("FETCH_CONTENTS_PERMISSION", {
    platform: "stv",
    contentsType: type,
    contentsId: id,
  });

  if (400 <= Number(response.status)) {
    return;
  }

  // 시청 권한이 없는 경우
  if (response.data.denied) {
    if (response.data.deniedReason == "stv_subscription_expiry") {
      // 이용권이 만료된 경우
      // ws 연결 해제, localstorage 초기화 진행
      store.dispatch("REQUEST_LOGOUT");
      router.replace({
        name: "expiry",
        params: {
          permission: "contents",
          t: new Date().getTime(),
        },
      });
      return;
    } else {
      // 이용권 변경 여부 체크
      const servicesResponse = await store.dispatch("FETCH_SERVICES", {
        platform: "stv",
      });

      if (servicesResponse.data.deniedReason == "stv_subscription_expiry") {
        // 이용권이 만료된 경우
        // ws 연결 해제, localstorage 초기화 진행
        store.dispatch("REQUEST_LOGOUT");
        router.replace({
          name: "expiry",
          params: {
            permission: "services",
            t: new Date().getTime(),
          },
        });
        return;
      }

      router.push({
        name: "checkPermission",
        params: {
          deepLinkCheck,
        },
      });
    }
  } else {
    if (deepLinkCheck) {
      router.push({
        name: "player",
        params: {
          vodId: id,
          contentType: type,
        },
      });
    } else {
      // focus 처리 때문에 따로 router 처리
      return true;
    }
  }
}
